(ns portal.advertiser-configuration-page.db.whitelist
  (:require [clojure.spec.alpha :as spec]
            [common.form.core :as form]
            [common.util :refer [vec-dissoc]]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(defn whitelistable-domain? [v]
  ;; Modified from https://stackoverflow.com/a/106223
  (some? (re-matches #"^(\*\.|\b)(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$" v)))

(p/defphraser whitelistable-domain?
  [_ problem]
  {:message "This is not a valid allowlist domain"
   :in (:in problem)
   :problem problem})

(spec/def ::whitelist-url whitelistable-domain?)

(spec/def ::value
  (spec/keys :req-un [::whitelist-url]))

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.whitelist ::value)))

(def forward-events
  [{:events #{:resource.advertiser/patch-success}
    :dispatch-to [:form.whitelist/patch-success]}])

(def initial-value
  {:whitelist-url ""})

(form/register-form {:namespace :form.whitelist
                     :validate-form validate-form
                     :forward-events forward-events
                     :initial-value initial-value
                     :submit-event :form.whitelist/add-whitelist-url})

(rf/reg-event-fx :form.whitelist/add-whitelist-url
  [validate-form]
  (fn [{:keys [db]} [_]]
    (let [new-url (get-in db [:form.whitelist :value :whitelist-url])
          payload (-> db
                      (get-in [:form.advertiser-configuration :value])
                      (update :allowedClickurlDomains conj new-url)
                      (select-keys [:allowedClickurlDomains]))]
      {:db (assoc-in db [:form.advertiser-configuration :state]
                     {:status :pending})
       :dispatch [:resource.advertiser/patch payload]})))

(rf/reg-event-fx :form.whitelist/delete-whitelist-url
  (fn [{:keys [db]} [_ id]]
    (let [payload (-> db
                      (get-in [:form.advertiser-configuration :value])
                      (update :allowedClickurlDomains vec-dissoc id)
                      (select-keys [:allowedClickurlDomains]))]
      {:db (assoc-in db [:form.advertiser-configuration :state]
                     {:status :pending})
       :dispatch [:resource.advertiser/patch payload]})))

(rf/reg-event-db :form.whitelist/patch-success
  (fn [db _]
    (assoc-in db [:form.whitelist :value :whitelist-url]
              (:whitelist-url initial-value))))

(rf/reg-sub :form.whitelist/whitelist-urls
  (fn [db]
    (zipmap (range)
            (get-in db [:form.advertiser-configuration :value :allowedClickurlDomains]))))

(def use-bind-control (partial form/use-bind-control :form.whitelist))
(def use-error-message (partial form/use-error-message :form.whitelist))
